/* global localStorage */

import { authService } from '../services';

const member = JSON.parse(localStorage.getItem('member'));
const permission = member ? member.admin_permission : null;
const initialState = member
  ? { loggedIn: true, member, permission }
  : { loggedIn: false, member: null, permission: null};

const authModule = {
  namespaced: true,
  state: initialState,
  mutations: {
    loginSuccess  (state, member) {
      state.loggedIn = true;
      // state.member = member;
      state.member = member.member;
      state.permission = member.member.admin_permission;
    },
    loginFailure  (state) {
      state.loggedIn = false;
      state.member = null;
      state.permission = null;
    },
    SET_MEMBER (state, data) {
      state.member = data;
    }
  },
  actions: {
    async loginMember ({ commit }, data) {
      try {
        const result = await authService.login(data);

        if (result.data !== null) {
          result.data.member.admin_permission = JSON.parse(result.data.member.admin_permission);
          commit('loginSuccess', result.data);
          return result;
        }
      } catch (error) {
        commit('loginFailure');
        if (error.response) {
          return error.response;
        }
      }
    },
    logout () {
      authService.logout();
    },
    async register ({ commit }, data) {
      try {
        const result = await authService.register(data);
        if (result.data !== null) {
          commit('loginSuccess', result.data);
          return result;
        }
      } catch (error) {
        commit('loginFailure');
        if (error.response) {
          return error.response;
        }
      }
    },
    async updatePassword ({ commit }, data) {
      try {
        const result = await authService.updatePassword(data);
        return result;
      } catch (error) {
        if (error.response) {
          return error.response;
        }
      }
    },
    async requestForgetPassword ({ commit }, data) {
      try {
        const result = await authService.requestForgetPassword(data);
        return result;
      } catch (error) {
        if (error.response) {
          return error.response;
        }
      }
    },
    async verifyForgetPasswordToken ({ commit }, data) {
      try {
        const result = await authService.verifyForgetPasswordToken(data);
        return result;
      } catch (error) {
        if (error.response) {
          return error.response;
        }
      }
    },
    setMember ({ commit }, member) {
      commit('SET_MEMBER', member);
    },
    setMemberProfileImage ({ commit }, newIng) {
      if (newIng) {
        member.member_img_profile = newIng;
      }
      commit('SET_MEMBER', member);
    }
  },
  getters: {
    getLoginState (state) {
      return state.loggedIn;
    },
    getMember (state) {
      return state.member;
    },
    getPermission (state) {
      return state.permission;
    }
  }
};

export default authModule;
